module.exports = __webpack_public_path__ + "img/avatar-null.ad0c7566.jpeg";